
function getNewTooltipElement(content) {
    //block major block elements and scripts for now
    if (/<(div|script|iframe|section)/.test(content)) {
        console.error('Invalid tooltip content provided');
        return null;
    }

    const $element = document.createElement('span');
    $element.classList.add('hover-tooltip');

    const $contentContainer = document.createElement('span');
    $contentContainer.classList.add('hover-tooltip__content');

    $contentContainer.innerHTML = content;

    $element.append($contentContainer);

    return $element;
}


function setupTooltip($candidate) {
    let tooltipContent = $candidate.dataset.hoverTooltip;

    if (typeof tooltipContent !== 'string') {
        return;
    }

    tooltipContent = tooltipContent.trim();

    if (tooltipContent.length === 0) {
        return;
    }

    const $tooltip = getNewTooltipElement(tooltipContent);

    if (!$tooltip) {
        return;
    }

    $candidate.dataset.hoverTooltipInitialized = true;

    $candidate.append($tooltip);

    const showTooltip = e => {
        $tooltip.classList.add('hover-tooltip--displayed');
    };

    const hideTooltip = e => {
        $tooltip.classList.remove('hover-tooltip--displayed');
    };

    $candidate.addEventListener('mouseenter', showTooltip);
    $candidate.addEventListener('mouseover', showTooltip);
    $candidate.addEventListener('focus', showTooltip);

    $candidate.addEventListener('mouseleave', hideTooltip);
    $candidate.addEventListener('mouseout', hideTooltip);
    $candidate.addEventListener('blur', hideTooltip);
}

function setupNewTooltips() {
    const $candidates = document.querySelectorAll('[data-hover-tooltip]:not([data-hover-tooltip-initialized])');

    if ($candidates.length === 0) {
        return;
    }

    for (const $candidate of $candidates) {
        setupTooltip($candidate);
    }
}

export {
    setupNewTooltips,
    setupTooltip
}